import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-user-economy',
    templateUrl: './user-economy.component.html',
    styleUrls: ['./user-economy.component.scss'],
    standalone: false
})
export class UserEconomyComponent {
  @Input() mode: 'light' | 'dark' = 'light';
  @Input() amount: number;

  get textStyle() {
    return {
      color: this.color
    };
  }

  private get color() {
    if (this.mode === 'dark') {
      return '#ffffff';
    }
    return '#000000';
  }
}
